// frontend/src/pages/admin/FreelancerHub.jsx
// Combined Search + Manage Component with Tabs

import React, { useState } from 'react';
import FreelancerSearch from './FreelancerSearch';
import FreelancerBids from './FreelancerBids';

const FreelancerHub = () => {
  const [activeTab, setActiveTab] = useState('search'); // 'search' or 'manage'

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header with Tabs */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            Freelancer Projects
          </h1>
          
          {/* Tabs */}
          <div className="flex gap-4 border-b -mb-px">
            <button
              onClick={() => setActiveTab('search')}
              className={`pb-3 px-4 font-medium transition ${
                activeTab === 'search'
                  ? 'border-b-2 border-blue-600 text-blue-600'
                  : 'text-gray-600 hover:text-gray-800'
              }`}
            >
              <span className="flex items-center gap-2">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                Search & Import
              </span>
            </button>
            
            <button
              onClick={() => setActiveTab('manage')}
              className={`pb-3 px-4 font-medium transition ${
                activeTab === 'manage'
                  ? 'border-b-2 border-blue-600 text-blue-600'
                  : 'text-gray-600 hover:text-gray-800'
              }`}
            >
              <span className="flex items-center gap-2">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
                My Projects
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div className="max-w-7xl mx-auto">
        {activeTab === 'search' ? (
          <FreelancerSearch />
        ) : (
          <FreelancerBids />
        )}
      </div>
    </div>
  );
};

export default FreelancerHub;
